import eCreditFetch from "@/services/acc_interceptor.ts";
import API_CLS from "@/utils/api.ts";
import CommonClass from "@/utils/common.ts";
import {getModule} from "@/services/cms.ts";
import CMS from "@/utils/cms.ts";
import * as Sentry from "@sentry/react";

export default function useInits() {

    const isAuth = ():boolean => {
        let session_token = localStorage.getItem(CommonClass.local_storage_fields.session_token)
        return Boolean(typeof session_token === "string" && session_token?.length)
    }

    const setStorageRequestLoan = () => {
        const searchParams = new URLSearchParams(location.search);


        if(searchParams.get('amount')) {

            if(typeof searchParams.get('language') === "string" && ["ro", "ru"].includes(searchParams.get("language") as string)) {
                localStorage.setItem(CommonClass.local_storage_fields.i18nextLng, searchParams.get('language') as string)
            }

            let obj = {
                amn: searchParams.get('amount') || "",
                period: searchParams.get('period') || "",
                phone: searchParams.get('phone') || "",
                type: searchParams.get('type') || "",
                utm_source: searchParams.get('utm_source') || "",
                utm_campaign: searchParams.get('utm_campaign') || "",
            }
            let utmParams:any = {};
            
            for (const [key, value] of searchParams.entries()) {
                if (key.startsWith('utm_')) {
                    utmParams[key] = value;
                }
            }
            function jsonToBase64(jsonObject: Record<string, any>): string {
                const jsonString = JSON.stringify(jsonObject);
                return btoa(jsonString);
            }

            function setCookie(name: string, value: string, days: number, domain?: string): void {
                const date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                const expires = `expires=${date.toUTCString()};`;
                const domainPart = domain ? `Domain=${domain}; ` : "";
                
                document.cookie = `${name}=${value}; ${domainPart}SameSite=Lax; Path=/; Secure; ${expires}`;
            }

            const domain: string = window.location.hostname.replace(/^www\./, "");

            const base64UtmParams: string = jsonToBase64(utmParams);

            setCookie("ec_utm", base64UtmParams, 30, domain);
            
            sessionStorage.setItem(CommonClass.local_storage_fields.apply_credit_form_body, JSON.stringify(obj))
            history.replaceState({}, document.title, window.location.pathname);
        }
        
    }
    
    setStorageRequestLoan()
    
    const getAllDocs = async () => {
        const res = await getModule(CMS.module.app_docs);
        const list = res?.response?.data;

        if (Array.isArray(list) && list.length) {
            
            
            list.map((obj: any) => {
                let t = obj?.cache?.types
                let target_obj = t.find((x:any) => Boolean(x.doc?.value?.d_value))

                if(typeof target_obj === "object") {
                    let { api_id, types } = target_obj.doc?.value?.d_value;
                    let result_obj = {}


                    if(Array.isArray(types) && types.length) {
                        if(types.length == 1) {
                            if(types[0]?.type !== "doc_list") {
                                result_obj = CMS.getAllFields(types[0]);
                            } else {
                                result_obj = types[0];
                            }
                        } else {
                            if(api_id == "confirm-identity"){
                                const needed_type = types.find((x:any) => x.type === "upload_photo_instructions");
                                result_obj = CMS.getAllFields(needed_type);
                            }

                            if(api_id == "pep"){
                                const needed_type = types.find((x:any) => x.type === "info_page");
                                result_obj = CMS.getAllFields(needed_type);
                            }
                        }

                        if (typeof api_id === "string" && typeof (CMS as any)[api_id] === "object") {
                            try {
                                (CMS as any)[api_id] = result_obj;

                            } catch(e) {
                                Sentry.captureException(e, { tags: { section: "init", action: "get_all_docs" } })
                            }
                        }

                    }


                }

            });
        }
    };
    
    const auth_listener = async () => {
        const searchParams = new URLSearchParams(location.search);
        
        const mpassResponse = searchParams.get('mpass_response');
        
        if (typeof mpassResponse === "string") {
            const decodedData = atob(mpassResponse);
            const obj = JSON.parse(decodedData)
            
            if(typeof obj === "object") {
                if(obj.Message === "success" && obj.Status){
                    localStorage.setItem(CommonClass.local_storage_fields.session_token, "byBwdWxhIHRpZSBkYSBudSB0b2tlbg==")
                }
            }
        }

    }

    
    // const deleteAllCookies = () => {
    //     // const today = new Date();
    //     // const targetDate = "2025-02-12";
    //     // const todayStr = today.toISOString().split("T")[0];
    //     // const updatedCookies = localStorage.getItem("updated_cookies");
    //
    //     // if (updatedCookies === null || (typeof updatedCookies === "string" && updatedCookies !== "true")) {
    //         Object.keys(Cookies.get()).forEach((cookieName) => {
    //             Cookies.remove(cookieName, { path: "/" });
    //         });
    //
    //         localStorage.setItem("updated_cookies", "true");
    //         console.info("Cookies deleted!");
    //     // } else {
    //     //     console.info("No cookie deletion today.");
    //     // }
    // };

    
    const init_function = async () => {

        // deleteAllCookies();
        await auth_listener().then(() => {
            CommonClass.init_auth = isAuth()
        })

        return new Promise(async (resolve:any) => {
            await eCreditFetch(API_CLS.common.settings,{
                method: API_CLS.methods.Get,
            })
                .then((res) => res.json())
                .then(async (body) => {

                    // localStorage.setItem(CommonClass.local_storage_fields.device_uid, getDeviceUUID() || "")

                    if (body.hasOwnProperty("message") && body.message === "ok") {
                        CommonClass.general_settings = body?.settings;

                        if(Object.keys(CommonClass.general_settings).length) {
                            
                            // let storage_uid = localStorage.getItem(CommonClass.local_storage_fields.device_uid)
                            
                            // if(storage_uid === null) {

                            // }
                            
                            getAllDocs().then(() => {
                                resolve();
                            })
                            
                        }
                    }
                }).catch(() => {
                    resolve();
                })
        })
    }
    
    return {
        init_function
    }
}

